"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.PolarisSideNav = void 0;
const react_1 = __importDefault(require("react"));
const styled_components_1 = __importDefault(require("styled-components"));
const react_router_dom_1 = require("react-router-dom");
const polaris_1 = require("@shopify/polaris");
const launchdarkly_react_client_sdk_1 = require("launchdarkly-react-client-sdk");
const polaris_icons_1 = require("@shopify/polaris-icons");
/**
 * The polaris nav doesn't have a lot of color customization options, so
 * manual CSS overrides are done here in the styled nav wrapper.
 */
const StyledNavWrapper = styled_components_1.default.div `
  .Polaris-Navigation__Item--disabled {
    display: none;
  }

  .Polaris-Indicator--pulseIndicator {
    display: none;
  }

  .Polaris-Navigation {
    padding-top: 52px;
  }
`;
const PolarisSideNav = () => {
    const location = (0, react_router_dom_1.useLocation)();
    const navigate = (0, react_router_dom_1.useNavigate)();
    const flags = (0, launchdarkly_react_client_sdk_1.useFlags)();
    const reportNavItems = {
        activeOrders: {
            url: '/reports/active_orders',
            label: 'Active Orders',
            new: false,
            disabled: !flags.activeOrders
        },
        timeInFulfillment: {
            url: '/reports/time_in_fulfillment',
            label: 'Time in Fulfillment',
            new: true,
            disabled: !flags.timeInFulfillmentReport
        },
        timeInTransit: {
            url: '/reports/time_in_transit',
            label: 'Time in Transit',
            new: false,
            disabled: !flags.timeInTransitReport
        },
        shippingPerformance: {
            url: '/reports/shipping_performance',
            label: 'Shipping Performance'
        },
        problemOrders: {
            url: '/reports/problem_orders',
            disabled: false,
            label: 'Problem Orders'
        },
        revenueReport: {
            url: '/reports/revenue_report',
            label: 'Revenue',
            disabled: !flags.revenueReport
        },
        emailPerformance: {
            url: '/reports/email_performance',
            label: 'Email Performance',
            disabled: !flags.emailPerformanceReport,
            new: true
        }
    };
    const navItems = {
        orders: {
            url: '/orders',
            label: 'Orders',
            icon: polaris_icons_1.OrderFilledIcon
        },
        shipments: {
            url: '/shipments',
            label: 'Shipments',
            icon: polaris_icons_1.OrderFilledIcon,
            badge: 'Beta',
            disabled: !flags.shipmentsPage
        },
        customers: {
            url: '/customers',
            label: 'Customers',
            icon: polaris_icons_1.PersonFilledIcon
        },
        reports: {
            url: '/reports/active_orders',
            label: 'Reports',
            icon: polaris_icons_1.ChartVerticalFilledIcon,
            disabled: !flags.metabaseReports,
            onClick: () => navigate('/reports/active_orders'),
            subNavigationItems: Object.keys(reportNavItems).map((key) => {
                const item = reportNavItems[key];
                return Object.assign(Object.assign({}, item), { selected: location.pathname.includes(item.url) });
            })
        },
        trackingPageCreator: {
            url: '/tracking_page_creator',
            label: 'Tracking Page Creator',
            icon: polaris_icons_1.ContentFilledIcon,
            disabled: !flags.externalTrackingPage
        },
        trackingPageManager: {
            url: '/tracking-page/manager',
            label: 'Tracking Pages',
            badge: 'Legacy',
            icon: polaris_icons_1.ContentFilledIcon,
            disabled: !flags.trackingPageManager
        },
        estimatedDeliveryDate: {
            url: '/estimated-delivery-date/config',
            label: 'Estimated Delivery Date',
            icon: polaris_icons_1.ClockIcon,
            disabled: !flags.estimatedDeliveryDate
        },
        transactionalEmails: {
            url: '/transactional_emails',
            label: 'Transactional Emails',
            icon: polaris_icons_1.EmailIcon,
            disabled: !flags.transactionalEmailsPage
        },
        apps: {
            url: '/apps',
            label: 'Apps',
            icon: polaris_icons_1.AppsFilledIcon,
            disabled: !flags.installableApps
        },
        postPurchasePlays: {
            url: '/post_purchase_plays',
            label: 'Post Purchase Plays',
            icon: polaris_icons_1.PlanFilledIcon,
            disabled: !flags.airtableIntegration
        },
        knowledgebase: {
            url: 'https://help.gomalomo.com/csc/',
            label: 'Knowledge Base',
            icon: polaris_icons_1.BankFilledIcon
        },
        malomoStatus: {
            url: 'https://status.gomalomo.com',
            label: 'Malomo Status',
            icon: polaris_icons_1.ChartLineIcon
        },
        account: {
            url: '/account',
            label: 'Account',
            icon: polaris_icons_1.SettingsFilledIcon
        },
        offers: {
            url: '/offers',
            label: 'Offers',
            icon: polaris_icons_1.MegaphoneFilledIcon,
            disabled: !flags.airtableIntegration || !flags.airtablePromotions
        }
    };
    return (react_1.default.createElement(StyledNavWrapper, null,
        react_1.default.createElement(polaris_1.Navigation, { location: location.pathname },
            react_1.default.createElement(polaris_1.Navigation.Section, { fill: true, 
                // @ts-expect-error ts(2322) force banner customization
                items: Object.keys(navItems).map((key) => {
                    const item = navItems[key];
                    return Object.assign(Object.assign({}, item), { selected: location.pathname.includes(item.url) });
                }) }))));
};
exports.PolarisSideNav = PolarisSideNav;
